<div>
  <h1>{{ translationService.getProductIngredientInformationText() }}</h1>
  <div [formGroup]="ingredientForm" class="ingredient-form-container">
    <div class="fullIngredientDisclosure">
      <label
        id="fullIngredientDisclosureLabel"
        for="fullIngredientDisclosure"
        >{{
          translationService.getFullIngredientDisclosureQuestionText()
        }}</label
      >
      <mat-radio-group
        aria-labelledby="fullIngredientDisclosureLabel"
        formControlName="fullIngredientDisclosure"
      >
        <mat-radio-button value="true"
          >{{ translationService.getYesText() }}
        </mat-radio-button>
        <mat-radio-button value="false"
          >{{ translationService.getNoText() }}
        </mat-radio-button>
      </mat-radio-group>
    </div>
    <ng-container formArrayName="ingredients">
      @for (
        currentIngredientForm of ingredients.controls;
        track currentIngredientForm;
        let ingredientIndex = $index
      ) {
        <form
          [formGroup]="getIngredientFormAsFormGroup(ingredientIndex)"
          class="ingredient-row"
        >
          <div class="custom-form-row">
            <mat-checkbox
              formControlName="mayContain"
              (change)="onMayContainChange($event.checked, ingredientIndex)"
            >
              {{ translationService.getMayContainText() }}
            </mat-checkbox>
            <mat-checkbox
              formControlName="doesNotContain"
              (change)="onDoesNotContainChange($event.checked, ingredientIndex)"
            >
              {{ translationService.getDoesNotContainText() }}
            </mat-checkbox>
            <mat-checkbox formControlName="optionallyDisclosed">
              {{ translationService.getOptionallyDisclosedText() }}
            </mat-checkbox>
          </div>
          <div class="custom-form-row">
            <mat-form-field appearance="outline" class="input-lg">
              <input
                matInput
                #autoCompleteTextInput
                [matAutocomplete]="auto"
                placeholder="Search for an ingredient"
                formControlName="nameWithAliases"
                (keyup)="onIngredientChange($event, ingredientIndex)"
              />
              <mat-autocomplete
                #auto="matAutocomplete"
                [displayWith]="displayName"
                color="primary"
                class="grey-search-autocomplete"
                (optionSelected)="onSelectionChanged($event, ingredientIndex)"
              >
                @for (
                  ingredient of filteredOptions[ingredientIndex];
                  track ingredient
                ) {
                  <mat-option
                    [value]="ingredient"
                    [disabled]="ingredient.id === ''"
                  >
                    <span class="white-highlight-select ingredient-name">{{
                      ingredient.nameWithAliases
                    }}</span>
                  </mat-option>
                } @empty {
                  <mat-option value="null"
                    >{{ translationService.getNoResultsText() }}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
            <mat-form-field class="input-md" appearance="outline">
              <mat-label>{{ translationService.getRangeCodeText() }}</mat-label>
              <mat-select
                (selectionChange)="onRangeCodeChange($event, ingredientIndex)"
                [disabled]="
                  checkForMayContain(ingredientIndex) ||
                  checkForDoesNotContain(ingredientIndex)
                "
              >
                @for (rangeCode of rangeCodes; track rangeCode) {
                  <mat-option [value]="rangeCode.code"
                    >{{ rangeCode.code }} = {{ rangeCode.lowerBound }}% -
                    {{ rangeCode.upperBound }}%
                  </mat-option>
                }
                <mat-option value="null"
                  >{{ translationService.getNaText() }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="input-md" appearance="outline">
              <mat-label
                >{{ translationService.getUpperConcentrationText() }}
              </mat-label>
              <input
                matInput
                name="upperConcentration"
                formControlName="upperConcentration"
                autocomplete="off"
              />
            </mat-form-field>
            <mat-form-field class="input-md" appearance="outline">
              <mat-label
                >{{ translationService.getLowerConcentrationText() }}
              </mat-label>
              <input
                matInput
                name="lowerConcentration"
                formControlName="lowerConcentration"
                autocomplete="off"
              />
            </mat-form-field>
          </div>
          <div class="custom-form-row">
            <p class="input-lg">
              {{ translationService.getSelectiveDisclosureMessage() }}
            </p>
          </div>
          <div class="custom-form-row">
            <mat-form-field class="input-lg" appearance="outline">
              <mat-label>User Groups</mat-label>
              <mat-select formControlName="disclosureRoleIds" multiple>
                @for (role of selectiveDisclosureRoles; track role) {
                  <mat-option [value]="role.id">{{ role.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="custom-form-row">
            <button
              mat-stroked-button
              extended
              color="primary"
              class="action-item remove-btn"
              (click)="removeIngredient(ingredientIndex)"
            >
              <mat-icon>delete</mat-icon>
              {{ translationService.getRemoveText() }}
            </button>
          </div>
        </form>
        <br />
        <mat-divider></mat-divider>
      }
    </ng-container>
  </div>
  <div>
    <div class="actions margin-top-10">
      <button
        mat-raised-button
        extended
        color="primary"
        class="action-item"
        (click)="onSubmit()"
      >
        <mat-icon>add</mat-icon>
        {{ translationService.getNextText() }}
      </button>
      <button
        mat-raised-button
        extended
        color="primary"
        class="action-item"
        (click)="goBack()"
      >
        <mat-icon>arrow_back</mat-icon>
        {{ translationService.getBackText() }}
      </button>
      <button
        mat-raised-button
        extended
        color="primary"
        class="action-item"
        (click)="addIngredientRow()"
      >
        <mat-icon>add</mat-icon>
        {{ translationService.getAddIngredientText() }}
      </button>
      <button
        type="button"
        mat-stroked-button
        extended
        color="primary"
        class="action-item"
        (click)="onReset()"
      >
        <mat-icon>refresh</mat-icon>
        {{ translationService.getResetText() }}
      </button>
    </div>
  </div>
</div>
